import { LinearProgress, linearProgressClasses, styled } from '@mui/material';

interface BorderLinearProgressProps {
  colorOverride?: string;
}

export const BorderLinearProgress = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== 'colorOverride',
})<BorderLinearProgressProps>(({ theme, colorOverride }) => ({
  height: 15,
  borderRadius: 15,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 0,
    background: `linear-gradient(to right, ${colorOverride || 'var(--tgui--button_color)'}, ${colorOverride || 'var(--tgui--button_color)'})`,
  },
}));